<template>
  <v-container>
    <div class="breadcrumb-wrap">
      <v-breadcrumbs :items="breadcrumbs" />
    </div>
    <div class="form-npa private-pg">
      <div class="position">
        <div class="bg-white p-20">
          <div class="form-head">
            <Widget position="menu_profile" />
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn
                        dark
                        v-on="on"
                        class="navbar-toggler-profile"
                >
                  {{ $t("Профиль") }} <span class="caret"></span>
                </v-btn>
              </template>
              <v-list class="navbar-collapse">
                <v-list-item>
                  <Widget position="menu_profile" />
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
          <div class="form-body">
            <div class="private-section">
              <v-simple-table v-if="items.length">
                <thead>
                  <tr>
                    <th v-for="(value, field) in tableFields" :key="field">
                      <a @click="sortData(field)">
                        <i class="pro-icon-arrow-bottom1"></i>
                        {{ value }}
                      </a>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr :class="{ unread: !read }" v-for="{ item, npa, npaVersion, npaVersionBlock, read } in items" :key="item.id">
                    <td>
                      <router-link
                        :title="item.text |strippedContent"
                        active-class="active"
                        :to="$i18nRoute({
                          name: 'view-npa',
                          params: { id: npa.id },
                          query: { comment: item.id, ver:npaVersion, block: npaVersionBlock}
                        })"
                        :key="item.id"
                      >
                        <div v-html="item.text"></div>
                      </router-link>
                    </td>
                    <td>
                      {{ new Date(item.date) | dateFormat('DD.MM.YYYY') }}
                    </td>
                    <td>{{ npa.view.transName }}</td>
                    <td>
                      <router-link
                        :title="npa.transProjectGoal | strippedContent"
                        active-class="active"
                        :to="$i18nRoute({
                          name: 'view-npa',
                          params: { id: npa.id },
                        })"
                      >
                        {{ npa.transName }}
                      </router-link>
                    </td>
                    <td>
                      <span v-for="category in npa.category" :key="category.id">
                        {{ category.transName }},
                      </span>
                    </td>
                    <td>{{ item.status.transName }}</td>
                    <td>
                      {{
                        new Date(npa.discussion_period_date_to)
                          | dateFormat('DD.MM.YYYY')
                      }}
                    </td>
                    <td>
                      {{
                        item.is_npa_offer ? 'Да' : 'Нет'
                      }}
                    </td>
                  </tr>
                </tbody>
              </v-simple-table>
              <div class="private-footer">
                <p>{{ $t("Общее количество НПА") }}: {{ itemsTotal }}</p>
              </div>

              <v-pagination
                v-model="page"
                :length="pagesCount"
                :total-visible="7"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </v-container>
</template>

<script>
import { mapMutations } from 'vuex'
import Widget from '@/components/app/Widget'
import Npa from '@/model/npa'
import {Trans} from "@/plugins/Translation"

export default {
  components: {
    Widget
  },
  data: () => ({
    breadcrumbs: [],
    tableFields: {},
    items: [],
    sorting: {},
    sortSettings: {
      text: null,
      date: null,
      view: null,
      name: null,
      category: null,
      status: null,
      discussionPeriodDateTo: null,
      isNpaOffer: null
    },
    itemsTotal: 0,
    page: 1,
    pagesCount: 1
  }),
  watch: {
    $route: 'fetchData',
    page() {
      this.fetchData()
    }
  },
  created() {
    this.fetchData()
    this.scrollToTop()
  },
  methods: {
    ...mapMutations(['setLoading']),
    fetchData() {
      this.setLoading(true)
      this.sorting.page = this.page

      Npa.getComments(this.sorting)
        .then((response) => {
          this.items = response.items
          this.breadcrumbs = [
            { text: this.$i18n.t('Профиль'), disabled: false, href: Trans.currentLocaleUrl + '/profile' },
            { text: this.$i18n.t('Комментарии'), disabled: true }
          ]
          const paginator = response.paginationData
          this.itemsTotal = paginator.totalCount
          this.pagesCount = paginator.pageCount
          this.tableFields = {
            text: this.$i18n.t('Комментарии'),
            date: this.$i18n.t('Дата'),
            view: this.$i18n.t('Вид проекта НПА'),
            name: this.$i18n.t('Наименование'),
            category: this.$i18n.t('Категории'),
            status: this.$i18n.t('Статус'),
            discussionPeriodDateTo: this.$i18n.t('Дата окончания обсуждения'),
            isNpaOffer: this.$i18n.t('Предложение по проекту НПА')
          }
          this.setLoading(false)
        })
        .catch((error) => {
          this.$router.push(Trans.i18nRoute({
            name: 'error',
            params: {
              status: error.response.status
            }
          }))
          this.setLoading(false)
        })
    },
    sortData(sortKey) {
      if (
        !this.sortSettings[sortKey] ||
        this.sortSettings[sortKey] === 'desc'
      ) {
        this.sortSettings[sortKey] = 'asc'
      } else {
        this.sortSettings[sortKey] = 'desc'
      }

      this.page = 1

      this.sorting = {
        page: this.page,
        orderBy: sortKey,
        orderDir: this.sortSettings[sortKey]
      }
      this.fetchData()
    },
    scrollToTop() {
      window.scrollTo(0, 0)
    }
  }
}
</script>
